export const TASK_LIST_BY_PROJECT_ID = '/task/list';
export const TASK_CREATE = '/task/create';
export const TASK_UPDATE = '/task/update';
export const TASK_LIST_BY_USER = '/task/list-user-task';
export const TASK_DELETE = '/task/delete';
export const TASK_DETAILS = '/task/details';
export const COMMENT_CREATE = '/comment/create';